import { Card, Spin } from 'antd';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getSingleVirtualAccount } from '../../methods/redux/reducers/virtual-fiat-account';

const SingleVirtualFiatAccount = () => {
	const dispatch = useAppDispatch();
	const { id } = useParams<{ id: string }>();
	const { singleData } = useAppSelector((store) => store.virtualFiatAccount);

	useEffect(() => {
		if (id) {
			dispatch(getSingleVirtualAccount(id));
		}
	}, [id, dispatch]);

	if (!singleData) {
		return (
			<Card>
				<Spin size="large" />
			</Card>
		);
	}

	return (
		<Card>
			<h1>Virtual Fiat Account Details</h1>
			<div>
				<p><strong>User ID:</strong> {singleData.userId?._id}</p>
				<p><strong>Username:</strong> {singleData.userId?.username}</p>
				<p><strong>Email:</strong> {singleData.userId?.email}</p>
				<p><strong>Account Number:</strong> {singleData.accountNumber}</p>
				<p><strong>Bank Name:</strong> {singleData.bankName}</p>
				<p><strong>Provider Key:</strong> {singleData.providerKey}</p>
				<p><strong>Status:</strong> {singleData.status}</p>
				<p><strong>Balance:</strong> {singleData.balance}</p>
				<p><strong>Currency:</strong> {singleData.currency}</p>
				<p><strong>Is Short Lived:</strong> {singleData.isShortLived ? 'Yes' : 'No'}</p>
				<p><strong>Created At:</strong> {new Date(singleData.createdAt).toLocaleString()}</p>
				<p><strong>Updated At:</strong> {new Date(singleData.updatedAt).toLocaleString()}</p>
			</div>
		</Card>
	);
};

export default SingleVirtualFiatAccount;